var React = require('react');

function UserLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M256 32c61.8 0 112 50.2 112 112s-50.2 112-112 112-112-50.2-112-112S194.2 32 256 32m128 320c52.9 0 96 43.1 96 96v32H32v-32c0-52.9 43.1-96 96-96 85 0 67.3 16 128 16 60.9 0 42.9-16 128-16M256 0c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144S335.5 0 256 0zm128 320c-92.4 0-71 16-128 16-56.8 0-35.7-16-128-16C57.3 320 0 377.3 0 448v32c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-32c0-70.7-57.3-128-128-128z"}));
}

UserLight.defaultProps = {"aria-hidden":"true","focusable":"false","data-prefix":"fal","data-icon":"user-alt","role":"img","viewBox":"0 0 512 512","className":"svg-inline--fa fa-user-alt fa-w-16 fa-3x"};

module.exports = UserLight;

UserLight.default = UserLight;
